module.exports = Object.freeze({
  ERROR: 'ERROR',
  LOADING: 'LOADING',
  RESET: 'RESET',
  PAGE_LOAD: 'PAGE_LOAD',
  LOGGED_OUT: 'LOGGED_OUT',
  USER: 'USER'
})
